import React, { useState, useEffect } from "react";
import AutoComplete from './AutoComplete'

import {
  TextField,
  Typography, 
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Autocomplete,
  Grid
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Controller, useFormContext } from "react-hook-form";
import { format } from "date-fns";
import parse from 'autosuggest-highlight/parse';
import { debounce } from '@mui/material/utils';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import axios from "axios"

const GOOGLE_MAPS_API_KEY = 'AIzaSyDIpgxqYO9f0SakTwp64IOjvgc6ysMcirg';


//Personal Infromation starts here
const Patient = ({
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
  handlePlaceSelect,
  handleSubmit,
  setFieldValue,
  setFieldError,
  setFieldTouched
}) => {

  const [value, setValue] = React.useState('');
  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState([]);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [gender, setGender] = React.useState("");
  const handleChanging = (event) => {
    setGender(event.target.value);
  };

  // const handleEmail = async(e) => {
  //  var email = e.target.value
  //  setFieldValue("email", email)
  //  try{
  //   await axios.post("https://qakdci.seekinterns.com/2222/duplicateemailcheck", {
  //     email
  //   }).then((res) => {
  //     if(res.data.response !== "unique"){
  //       setFieldError("email", "Email Already Exists")
  //     }
  //   })
  //  } catch(e) {
  //   console.error(e)
  //  }
  // }

  return (
    <>
      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(4, minmax(0, 1fr))"
        sx={{
          "& > div": {
            gridColumn: isNonMobile ? undefined : "span 4",
          },
        }}
      >
        <TextField
        fullWidth
          type="text"
          label="First Name*"
          onBlur={handleBlur}
          onChange={handleChange}
          name="firstName"
          value={values.firstName}
          error={!!touched.firstName && !!errors.firstName}
          helperText={touched.firstName && errors.firstName}
          sx={{ gridColumn: "span 1" }}
        />

        <TextField
          fullWidth
          type="text"
          label="Last Name*"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.lastName}
          name="lastName"
          error={!!touched.lastName && !!errors.lastName}
          helperText={touched.lastName && errors.lastName}
          sx={{ gridColumn: "span 1" }}
        />

        <TextField
          fullWidth
          type="text"
          label="Email*"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.email}
          name="email"
          error={touched.email && !!errors.email}
          helperText={touched.email && errors.email}
          sx={{ gridColumn: "span 2" }}
          
        />
          
        <TextField
          fullWidth
          type="text"
          label="Enter Mobile Number*"
          onBlur={handleBlur}
          name="contact"
          onChange={handleChange}
          value={values.contact}
          error={!!touched.contact && !!errors.contact}
          helperText={touched.contact && errors.contact}
          sx={{ gridColumn: "span 2" }}
        />

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Date Of Birth *"
            onBlur={handleBlur}
            format="MM/DD/YYYY"
            value={values.dateofbirth}
            name="dateofbirth"
            onChange={(date) =>{setFieldValue("dateofbirth", date)} }
            renderInput={(params) => <TextField {...params} />}
            error={!!touched.dateofbirth && !!errors.dateofbirth}
            helperText={touched.dateofbirth && errors.dateofbirth}
          />
        </LocalizationProvider>

        <FormControl fullWidth>
          <InputLabel id="gender">Gender</InputLabel>
          <Select
            labelId="gender"
            id="gender"
            value={values.gender}
            label="Gender"
            name="gender"
            onBlur={handleBlur}
            onChange={handleChange}
            error={!!touched.gender && !!errors.gender}
            helperText={touched.gender && errors.gender}
            sx={{ gridColumn: "span 2" }}
          >
            <MenuItem value={"M"}>Male</MenuItem>
            <MenuItem value={"F"}>Female</MenuItem>
            <MenuItem value={"O"}>Other</MenuItem>
          </Select>
        </FormControl>

       
        {/* <TextField
          fullWidth
          type="text"
          label="Marital Status"
          onBlur={handleBlur}
          onChange={handleChange}
          name="marital_status"
          value={values.marital_status}
          sx={{ gridColumn: "span 4" }}
        /> */}

        <TextField
          fullWidth
          type="text"
          label="Occupation & Employer"
          name="occupation"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.occupation}
          sx={{ gridColumn: "span 2" }}
        />

        <TextField
          fullWidth
          type="text"
          label="SSN (optional)"
          onBlur={handleBlur}
          name="ssn"
          onChange={handleChange}
          value={values.ssn}
          sx={{ gridColumn: "span 1" }}
        />

<FormControl fullWidth>
          <InputLabel id="marital_status">Marital Status</InputLabel>
          <Select
            labelId="marital_status"
            id="marital_status"
            value={values.marital_status}
            label="Marital Status"
            name="marital_status"
            onBlur={handleBlur}
            onChange={handleChange}
            error={!!touched.marital_status && !!errors.marital_status}
            helperText={touched.marital_status && errors.marital_status}
            sx={{ gridColumn: "span 2" }}
          >
            <MenuItem value={"S"}>Single</MenuItem>
            <MenuItem value={"M"}>Married</MenuItem>
            <MenuItem value={"D"}>Divorced</MenuItem>
            <MenuItem value={"W"}>Widowed</MenuItem>
          </Select>
        </FormControl>

        {/* <TextField
          fullWidth
          id="address1"
          type="text"
          label="Address 1"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.address1}
          name="address1"
          error={!!touched.address1 && !!errors.address1}
          helperText={touched.address1 && errors.address1}
          sx={{ gridColumn: "span 2" }}
        />  */}

{/* <TextField
          fullWidth
          type="text"
          id="address2"
          label="Address 2"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.address2}
          name="address2"
          error={!!touched.address2 && !!errors.address2}
          helperText={touched.address2 && errors.address2}
          sx={{ gridColumn: "span 2" }}
        />  */}

      

      {/* <Autocomplete
      disablePortal
      id="google-map-demo"
      name="address2"
      sx={{ gridColumn: "span 2" }}
      getOptionLabel={(option, value) =>
        // (option) => option?.name
        typeof option === 'string' ? option : option.description
      }
      filterOptions={(x) => x}
      options={options}
      autoComplete
      includeInputInList
      filterSelectedOptions
      value={values.address2}
      noOptionsText="No locations"
      onChange={(event, newValue) => {
        setOptions(newValue ? [newValue, ...options] : options);
        setValue(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField {...params} label="Address" fullWidth />
      )}
      renderOption={(props, option) => {
        const matches =
          option.structured_formatting.main_text_matched_substrings || [];
        const parts = parse(
          option.structured_formatting.main_text,
          matches.map((match) => [match.offset, match.offset + match.length]),
        );

        return (
          <li {...props}>
            <Grid container alignItems="center">
              <Grid item sx={{ display: 'flex', width: 44 }}>
                <LocationOnIcon sx={{ color: 'text.secondary' }} />
              </Grid>
              <Grid item sx={{ width: 'calc(100% - 44px)', wordWrap: 'break-word' }}>
                {parts.map((part, index) => (
                  <Box
                    key={index}
                    component="span"
                    sx={{ fontWeight: part.highlight ? 'bold' : 'regular' }}
                  >
                    {part.text}
                  </Box>
                ))}
                <Typography variant="body2" color="text.secondary">
                  {option.structured_formatting.secondary_text}
                </Typography>
              </Grid>
            </Grid>
          </li>
        );
      }}
    />  */}

        {/* <TextField
          fullWidth
          id="city"
          type="text"
          label="City"
          name="city"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.city}
          error={!!touched.city && !!errors.city}
          helperText={touched.city && errors.city}
          sx={{ gridColumn: "span 4" }}
        />

        <TextField
          fullWidth
          id="country"
          type="text"
          label="Country"
          name="country"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.country}
          sx={{ gridColumn: "span 4" }}
        />

        <TextField
          fullWidth
          id="state"
          type="text"
          label="State"
          name="state"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.state}
          sx={{ gridColumn: "span 4" }}
        />

        <TextField
          fullWidth
          id="postcode"
          name="postal"
          type="text"
          label="Postal/Zip code"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.postal}
          sx={{ gridColumn: "span 4" }}
        /> */}
        
      </Box>
      <br />
      <AutoComplete 
        placesKey = "AIzaSyDIpgxqYO9f0SakTwp64IOjvgc6ysMcirg"
        inputId="address"
        value={values.city}
        onChange={handlePlaceSelect}
        //setAddress = {(addressObject) => console.log(addressObject)}
        required={true}
        setFieldValue={setFieldValue}
      />
    </>
  );
}

export default Patient;